import React from "react"
import { Box, BoxProps } from "@chakra-ui/react"

type Props = {
  count: number
  max?: number
} & BoxProps

const CountBadge = ({ count, max = 99, ...props }: Props) => {
  if (count <= 0) {
    return null
  }

  return (
    <Box
      as="span"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      minW="20px"
      h="20px"
      px="5px"
      borderRadius="full"
      bg="blue.500"
      color="white"
      fontSize="xs"
      fontWeight="semibold"
      lineHeight={1}
      sx={{ fontVariantNumeric: "tabular-nums" }}
      {...props}
    >
      {count > max ? `${max}+` : count}
    </Box>
  )
}

export default CountBadge
